// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".areaColumn{width:100%;position:relative;background:#fff}.areaColumn .highcharts-plot-background{fill:#fff}.areaColumn .highcharts-background{fill:transparent}.areaColumn .highcharts-point{fill:inherit!important;stroke:inherit!important;stroke-width:0px}.areaColumn .highcharts-axis-line,.areaColumn .highcharts-graph{stroke-width:0px}.areaColumn rect.highcharts-data-label-box{fill:transparent!important}", ""]);
// Exports
module.exports = exports;
